import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const TableAlignmentCenter = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path d="M13.5 8a.5.5 0 0 1-.5.5H3a.5.5 0 0 1 0-1h10c.28 0 .5.22.5.5Z" fill={color} />
        <path d="M10 4.08 8 6m0 0L6 4.08M8 6V1M6 11.92 8 10m0 0 2 1.92M8 10v5" stroke={color} strokeLinecap="round" />
      </svg>
    )
  },
)

export default TableAlignmentCenter
